import { render } from "./GroupList.vue?vue&type=template&id=7af0377c&scoped=true"
import script from "./GroupList.vue?vue&type=script&lang=ts"
export * from "./GroupList.vue?vue&type=script&lang=ts"

import "./GroupList.vue?vue&type=style&index=0&id=7af0377c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7af0377c"

export default script